module.exports = __webpack_public_path__ + "img/eda3fc4bbec90b6e55727257f2c531e5.png";